import { render, staticRenderFns } from "./createPrescription.vue?vue&type=template&id=0f7e4d6e&"
import script from "./createPrescription.vue?vue&type=script&lang=js&"
export * from "./createPrescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports